import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import Paper from 'material-ui/Paper';
import Snackbar from 'material-ui/Snackbar';
import { BlockForm } from './BlockForm';
import environment from '../../lib/RelayUtils';
import * as BlockAddMutation from '../../mutations/BlockAddMutation';
import {formDataToParams} from "./utils";

const bodyStyle = { backgroundColor: '#ef426f', height: 'auto', lineHeight: '16px', padding: 12, whiteSpace: 'pre-line' };

export const BlockCreate = withRouter((props) => {
	const {history} = props;
	const [snackbarMessage, setSnackbarMessage] = useState(undefined);
	const onSubmit = data => {
		const finalData = formDataToParams(data)
		BlockAddMutation.commit(environment, finalData, (error: ?Error) => {
			if (error) {
				setSnackbarMessage('Ошибка во время сохранения');
			} else {
				setSnackbarMessage('Пользователь успешно создан');
				history.push(`/blocks`)
			}
		})
	};

	const handleCloseSnackbar = () => setSnackbarMessage(undefined);

	return (
		<Paper style={{ width: '100%', padding: 16 }}>
			<BlockForm viewer={props.viewer} isCreation={true} onSubmit={onSubmit} />
			{snackbarMessage && <Snackbar
				open={true}
				bodyStyle={bodyStyle}
				message={snackbarMessage}
				onRequestClose={handleCloseSnackbar}
			/>}
		</Paper>
	);
});


// WEBPACK FOOTER //
// src/components/blocks/BlockCreate.js